// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"0b07e0cf","847":"2d70610d","1426":"48f0a0fb","2131":"f746d36d","2450":"0b07e0cf","2675":"0b07e0cf","3555":"7402029f","4743":"be8bee9c","6320":"b5d2daec","8545":"d9a266f7"}[chunkId] + ".chunk.css";
};